import styled, { css } from 'styled-components';
import { DrawerItem } from '@/components/Drawer/Drawer.styles';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Items = styled.div<{ $isFirst?: boolean }>`
  margin-top: ${({ $isFirst }) => ($isFirst ? '10px' : '20px')};
`;

export const Item = styled(DrawerItem)<{ $isLogOut?: boolean }>`
  padding: 0 15px;
  gap: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};

  ${({ $isLogOut }) =>
    $isLogOut &&
    css`
      color: ${({ theme }) => theme.palette.system.blue};
      justify-content: center;
    `}
`;

export const Content = styled.div`
  padding: 20px 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  height: 100%;
`;

export const List = styled.ul`
  padding-left: 20px;
  margin-block: 20px;
`;

export const ListItem = styled(Typography.Body)`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;
